import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import featureService from 'services/featureService';

export const useFetchPartnerFeatures = () => {
  return useQuery<any, AxiosError>({
    queryKey: ['fetchPartnerFeatures'],
    queryFn: () => featureService.getFeatures(),
    retry: 0,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
